import { Modal as MuiModal } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledModal = styled(MuiModal)(({ theme }) => {
  const contentWidth = "20rem";
  const modalWidth = "25rem";
  const paddingWidth = "2.5rem";
  return {

    backdropFilter:"blur(20px)",
    backgroundColor: theme.linearGradients.gradientB,
    borderRadius:theme.spacing(1),
    boxShadow: "24px",
    height: "fit-content",
    left: "50%",
    maxHeight: "90vh",
    overflow: "auto",
    padding: `1rem ${paddingWidth} 1.5rem 2.5rem`,
    top: "50%",
    transform: "translate(-50%, -50%)",
    width: modalWidth,

    ".MuiModal-backdrop":{
      backdropFilter:"none",
      background:"none",
      borderRadius:theme.spacing(1)

    },

    "p": {
      maxWidth: contentWidth,
      overflowWrap:"break-word"
    }
  };});
